/**
 * Utility functions for environment detection
 */

/**
 * Determines if the current environment is production
 * @returns {boolean} true if production, false if non-production (qa)
 */
// const nonProdEnvironments = ['qa', 'stg', 'dev', 'perf', 'gateway']; //non-prod envs

const nonProdEnvironments = ['qa']; 

export const isProductionEnvironment = () => {
    const hostname = window.location.hostname.split(".")[0];
    return !nonProdEnvironments.includes(hostname);
};

/**
 * Gets the current environment name
 * @returns {string} environment name (qa, or prod)
 */
export const getCurrentEnvironment = () => {
    const hostname = window.location.hostname.split(".")[0];
    const environment = nonProdEnvironments.includes(hostname) ? hostname : 'prod';
    return environment;
};